

function FixedColumn(props){

}


export default FixedColumn;